import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaEdit,
  FaTrashAlt,
  FaPlus,
  FaShareAlt,
  FaEye,
  FaDownload
} from "react-icons/fa";
import Profile from "../Profile/Profile";
import QRGenerator from "./QRGenerator";
import Breadcrumb from "../Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoIosCloseCircle } from "react-icons/io";
import whatsapp from "../public/assets/img/whatsapp.png";
import facebook from "../public/assets/img/facebook.png";
import twitter from "../public/assets/img/twitter.png";
import skype from "../public/assets/img/skype.png";
import linkedin from "../public/assets/img/linkedin.png";
import telegram from "../public/assets/img/telegram.png";
import email from "../public/assets/img/email.png";
import copy from "../public/assets/img/copy.png";
import no_user from "../public/assets/img/no_user.png";
import { updateSubscriptionStatus } from "../../utils/subscription";
import MetaHelmet from "../MetaHelmet";
import DeleteConfirmationModal from "../DeleteConfirmationModal";


const BusinessIndex = () => {

  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedBusinessId, setSelectedBusinessId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [businessToDelete, setBusinessToDelete] = useState(null);
  const [downloadDropdownOpen, setDownloadDropdownOpen] = useState(null);
  const downloadDropdownRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const routes = [
    { name: "Home", path: "/dashboard" },
    { name: "Vcards", path: "/vcards" },
  ];
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.download-dropdown')) {
        setDownloadDropdownOpen(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }

    const timeoutId = setTimeout(() => {
      const fetchBusinesses = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/business-list`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { search: searchTerm, per_page: 12 },
          });
          const businesses = response.data.business;
          if (Array.isArray(businesses)) {
            setUsers(businesses);
            setFilteredUsers(businesses);
            console.log("businesses", businesses)
            if (businesses.length > 0) {
              setSelectedBusinessId(businesses[0].id);
            }
          } else {
            setUsers([]);
          }
        } catch (err) {
          if (
            err.response &&
            err.response.status === 403 &&
            err.response.data.login_subscription === "Expired"
          ) {
            updateSubscriptionStatus("Expired");
            window.dispatchEvent(new Event("storage"));
            return;
          }
          setError("Failed to fetch business data. Please try again.");
        } finally {
          setLoading(false);
        }
      };

      fetchBusinesses();
    }, 500); // 500ms debounce

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  useEffect(() => {
    if (showDeleteModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [showDeleteModal]);

  const handleBusinessSelect = (businessId) => {
    setSelectedBusinessId(businessId);
  };

  const handleQRCodeDownload = async (businessId) => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }
    try {
      const response = await axios.get(
        `${API_BASE_URL}/download_business_card/${businessId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data && response.data.url) {
        window.open(response.data.url, '_blank');
      } else {
        throw new Error("Download URL not received");
      }
    } catch (error) {
      if (
        error.response &&
        error.response.status === 403 &&
        error.response.data.login_subscription === "Expired"
      ) {

        updateSubscriptionStatus("Expired");
        window.dispatchEvent(new Event("storage"));
        return;
      }
      console.error("Error downloading business card:", error);
      setError("Failed to open Business Card. Please try again.");
    }
  };

  const handleQRCodeImageDownload = async (businessId) => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}/download_business_card_image/${businessId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const data = response.data;
      if (data.status === "Success") {
        window.open(data.url, "_blank");
      } else {
        alert("Failed to download business card image: " + data.message);
      }
    } catch (err) {
      console.error("Error:", err);
      alert("An error occurred.");
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleEdit = (id) => {
    navigate(`/business/update/${id}`);
  };

  const openDeleteModal = async (id) => {
    setBusinessToDelete(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    const token = localStorage.getItem("token");
    try {
      await axios.delete(`${API_BASE_URL}/delete-business/${businessToDelete}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(users.filter((user) => user.id !== businessToDelete));
      setFilteredUsers(filteredUsers.filter((user) => user.id !== businessToDelete));
      toast.success("Business deleted Successfully");
    } catch (error) {
      setError("Error deleting business. Please try again.");
    } finally {
      setShowDeleteModal(false);
      setBusinessToDelete(null);
    }
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setBusinessToDelete(null);
  };

  const toggleSocialIcon = (userId) => {
    setSelectedUserId(selectedUserId === userId ? null : userId);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };


  useEffect(() => {
    if (isModalOpen) {
      document.body.classList.add("modal-open-bg-freeze");
    } else {
      document.body.classList.remove("modal-open-bg-freeze");
    }
  }, [isModalOpen]);

  const shareVCard = (platform, user) => {
    const vCardURL = `${process.env.REACT_APP_FRONTEND_URL}vcards/${user.slug}`;
    const platformURLs = {
      whatsapp: `https://wa.me/?text=${encodeURIComponent(
        `vCard URL: ${vCardURL}`
      )}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Flocalhost%3A3000%2Fvcard%2Ftest%3Fid%3D146
                 =${encodeURIComponent(`vCard URL: ${vCardURL}`)}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        `vCard URL: ${vCardURL}`
      )}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        `vCard URL: ${vCardURL}`
      )}`,
      email: `https://mail.google.com/mail/?view=cm&fs=1&to=&su=Check%20out%20this%20vCard&body=${encodeURIComponent(
        `vCard URL: ${vCardURL}`
      )}`,
      telegram: `https://t.me/share/url?url=${encodeURIComponent(
        `vCard URL: ${vCardURL}`
      )}&text=Check%20out%20this%20vCard`,
      skype: `skype:?chat&message=${encodeURIComponent(`${vCardURL}`)}`,

    };

    if (platform === "download") {
      const link = document.createElement("a");
      link.href = vCardURL;
      link.click();
    } else if (platformURLs[platform]) {
      window.open(platformURLs[platform], "_blank");
    }
  };

  const copyLink = (user) => {
    if (navigator.clipboard) {
      const linkToCopy = `${process.env.REACT_APP_FRONTEND_URL}vcards/${user.slug}`;
      navigator.clipboard.writeText(linkToCopy)
        .then(() => {
          closeModal();
          setTimeout(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
          }, 300);
        })
        .catch((err) => {
          console.error('Error copying link: ', err);
        });
    } else {
      const linkToCopy = `${process.env.REACT_APP_FRONTEND_URL}vcards/${user.slug}`;
      const textarea = document.createElement('textarea');
      textarea.value = linkToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      closeModal();
      setTimeout(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }, 300);
    }
  };

  if (loading) {
    return (
      <div id="loader-wrapper">
        <span className="loader"></span>
      </div>
    );
  }
  if (error) {
    return <p className="error-message">{error}</p>;
  }

  const handleClick = () => {
    localStorage.removeItem('business_id')
    navigate('/business/create')
  }

  const toggleDownloadDropdown = (id) => {
    if (downloadDropdownOpen === id) {
      setDownloadDropdownOpen(null);
    } else {
      setDownloadDropdownOpen(id);
    }
  };

  const closeDownloadDropdown = () => setDownloadDropdownOpen(null);

  return (
    <><MetaHelmet
      title={`Local Shouts | Vcards`}

    />
      <div className="container" id="business-index">
        <Breadcrumb routes={routes} />
        <div className="d-flex bg-white p-3 rounded-2 white-box-shadow">
          <div class="form-group search-bar d-flex">
            <input
              type="text"
              placeholder="Search by VCard name"
              value={searchTerm}
              onChange={handleSearch}
              class="form-control bg-light-gray border-0 py-2"
            />
            <div className="input-reset-div d-flex px-2 ms-3" onClick={() => setSearchTerm('')}>
              <svg fill="#000000" width="20px" height="20px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" className="input-reset">
                <path d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0" fillRule="evenodd" />
              </svg>
            </div>
          </div>
          <div className="action-bar ms-auto align-content-center">
            <button className="btn ls-btn main-btn" onClick={handleClick}>
              <FaPlus />&nbsp;Create
            </button>
          </div>
          <ToastContainer />
        </div>

        <div class="profile-container mt-4">
          {filteredUsers.length === 0 ? (
            <p className="text-center">No record found</p>
          ) : (
            <div className="d-flex flex-wrap">

              {filteredUsers.map((user) => (
                <div key={user.id} className="profile-card-container p-3">
                  <div className="profile-card d-flex flex-column bg-white p-4 position-relative white-box-shadow rounded-2">
                    <div className="profile-img d-flex mx-auto">
                      <img src={user.logo ? `${user.logo}` : `${no_user}`} className="w-100 circle-rounded" />
                    </div>
                    <div className="info-section d-flex flex-column text-center mt-2 mx-auto">
                      <div className="name">{user.full_name}</div>
                      <div className="b-info mt-2">{user.company_name}&nbsp;({user.designation})</div>
                    </div>
                    <div className="d-flex qr-code mx-auto">
                      <QRGenerator user={user} className="w-100" />
                    </div>
                    <div className="d-flex justify-content-between action-btn-group gap-3 mx-auto">
                      <Link to={`${process.env.REACT_APP_FRONTEND_URL}vcards/${user.slug}`} className="view-vcard-btn"
                        target="_blank"
                        rel="noopener noreferrer">
                        <i className="fa-solid fa-eye"></i>
                      </Link>

                      <div
                        className="cursor-pointer edit-btn"
                        onClick={() => handleEdit(user.id)}>
                        <i className="fa-solid fa-pen-to-square"></i>
                      </div>

                      <div
                        className="cursor-pointer share-btn"
                        onClick={() => toggleSocialIcon(user.id)}>
                        <i className="fa-solid fa-share-nodes"></i>
                      </div>
                      {/* <div className="cursor-pointer download-btn" onClick={() => handleQRCodeDownload(user.id)}>
                        <i className="fa-solid fa-download"></i>
                      </div>
                      <div className="cursor-pointer download-btn" onClick={() => handleQRCodeImageDownload(user.id)}>
                        <i className="fa-solid fa-download"></i>
                      </div> */}
                      <div className="position-relative download-dropdown" ref={downloadDropdownRef}>
                        <div
                          className="cursor-pointer download-btn"
                          onClick={() => toggleDownloadDropdown(user.id)}
                        >
                          <i className="fa-solid fa-download"></i>
                        </div>
                        {downloadDropdownOpen === user.id && (
                          <div
                            className="position-absolute bg-white border rounded shadow p-2"
                            style={{
                              top: "100%",
                              right: 0,
                              zIndex: 1000,
                              minWidth: "200px",
                            }}
                          >
                            <div
                              className="dropdown-item cursor-pointer py-1"
                              onClick={() => {
                                handleQRCodeDownload(user.id);
                                closeDownloadDropdown();
                              }}
                            >
                              Download PDF
                            </div>
                            <div
                              className="dropdown-item cursor-pointer py-1"
                              onClick={() => {
                                handleQRCodeImageDownload(user.id);
                                closeDownloadDropdown();
                              }}
                            >
                              Download Card Image
                            </div>
                          </div>
                        )}
                      </div>
                      {selectedUserId === user.id && isModalOpen && (
                        <div id="myModal" className="share-modal">
                          <div className="modal-content position-relative pt-3 gap-3">
                            <button
                              onClick={closeModal}
                              className="position-absolute border-0 close-modal-btn">
                              <IoIosCloseCircle />
                            </button>
                            <div className="d-flex justify-content-between">
                              <div>
                                <img
                                  src={whatsapp}
                                  alt="WhatsApp"
                                  style={{
                                    width: "2.7rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => shareVCard("whatsapp", user)}
                                />
                              </div>
                              <div>
                                <img
                                  src={facebook}
                                  alt="Facebook"
                                  style={{
                                    width: "2.7rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => shareVCard("facebook", user)}
                                />
                              </div>
                              <div>
                                <img
                                  src={twitter}
                                  alt="Twitter"
                                  style={{
                                    width: "2.7rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => shareVCard("twitter", user)}
                                />
                              </div>
                              <div>
                                <img
                                  src={linkedin}
                                  alt="Linkedin"
                                  style={{
                                    width: "2.7rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => shareVCard("linkedin", user)}
                                />
                              </div>
                            </div>
                            <div className="d-flex justify-content-between share-row-2">
                              <div>
                                <img
                                  src={email}
                                  alt="Email"
                                  style={{
                                    width: "2.7rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => shareVCard("email", user)}
                                />
                              </div>
                              <div>
                                <img
                                  src={telegram}
                                  alt="Telegram"
                                  style={{
                                    width: "2.7rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => shareVCard("telegram", user)}
                                />
                              </div>
                              <div>
                                <img
                                  src={skype}
                                  alt="Skype"
                                  style={{
                                    width: "2.7rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => shareVCard("skype", user)}
                                />
                              </div>
                              <div className="rounded-circle bg-dark p-2">
                                <img
                                  src={copy}
                                  alt="Copy"
                                  style={{
                                    width: "1.7rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => copyLink(user)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {copied && (
                        <div
                          style={{
                            position: "fixed",
                            bottom: "20%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            background: "rgba(0, 0, 0, 0.8)",
                            color: "white",
                            padding: "10px 20px",
                            borderRadius: "8px",
                            zIndex: 1000,
                            textAlign: "center"
                          }}
                        >
                          Link copied to clipboard!
                        </div>
                      )}

                    </div>
                    <div className="dropdown action-dropdown position-absolute">
                      <div
                        className="cursor-pointer delete-btn"
                        onClick={() => openDeleteModal(user.id)}>
                        <FaTrashAlt />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {
          showDeleteModal && (
            <DeleteConfirmationModal
              onConfirm={handleDelete}
              onCancel={closeDeleteModal}
            />
          )
        }

        <Profile setUsers={setUsers} />
      </div>
    </>
  );
};

export default BusinessIndex;